import {fabric} from 'fabric';
import ProofreadFile from '../../lib/ProofreadFile';

fabric.PRBase = fabric.util.createClass(fabric.Image, {
	type: 'PRBase',
  originX: "left",
  originY: "top",
  hasControls: false,
  hasBorders: false,
  selectable: false,
  hoverCursor: "default",
  left:0,
  top:0,
  evented: false,

  grayscale: false,

});


fabric.PRBase.prototype.initialize = function(obj) {
	this.callSuper('initialize', {});
  this.set({
    previewFilename: obj.previewFilename
  })
}

fabric.PRBase.prototype.render = function(ctx) {
  
  ctx.save();
  ctx.shadowColor = 'rgba(0,0,0,0.2)';      // 影の色
  ctx.shadowOffsetX = 3*this.canvas.getZoom();         // x 方向
  ctx.shadowOffsetY = 3*this.canvas.getZoom();
  ctx.shadowBlur = 8*this.canvas.getZoom();

  if (this.grayscale) ctx.filter = "grayscale(100%) contrast(0.5) brightness(1.3)";
  //if (this.grayscale) ctx.filter = "saturate(50%)";
  //this._render(ctx);
  this.callSuper('render', ctx);


  ctx.restore();
}



fabric.PRBase.prototype.toObject = function() {
  let option = {
    previewFilename: this.previewFilename,
  };
	let obj =  fabric.util.object.extend(this.callSuper('toObject'), option);
  
  let propNames = Object.keys(option).concat(['type','left','top','width','height']);
  let slimObj = {};
	Object.keys(obj).forEach( function(key) {
		if (propNames.indexOf(key) >= 0) slimObj[key] = obj[key];
	});

  return slimObj;
}

fabric.PRBase.fromObject = function(obj, callback) {
  ProofreadFile.getPreview(obj.previewFilename).then(ret=>{
    let base = new fabric.PRBase(obj);
    base.setSrc(URL.createObjectURL(ret), ()=>{
      base.set({
        left:-base.width/2,
        top:-base.height/2
      });
      callback(base);
    });
  });
}

export default fabric.PRBase;